const mutations = {
    setToken(state,data){
        state.token = data;
    },
    setCheckpoint(state,data){
        state.checkpoint = data;
    },
    setPage(state,data){
        state.page = data;
    }
}
export default mutations


// WEBPACK FOOTER //
// ./src/store/common/mutations.js